import React from "react";
import {
  Capabilities,
  DocType,
  PermissionName,
} from "../../clients/graphqlTypes.js";
import { Restricted } from "./Restricted.js";
import { RestrictedByCapabilityWithDebug } from "./RestrictedByCapability.js";
import {
  type DocumentByType,
  RestrictedByDocumentPermissionByTypeWithDebug,
} from "./RestrictedByDocumentPermissionByType.js";

interface Props extends Omit<
  React.ComponentProps<typeof Restricted>,
  "isRestricted"
> {
  capability: Capabilities | Capabilities[];
  document: DocumentByType;
  permissionByType: Partial<Record<DocType, PermissionName>>;
}

export const RestrictedByCapabilityAndDocumentPermissionByTypeWithDebug = ({
  capability,
  document,
  permissionByType,
  children,
  otherwise,
  ...props
}: Props) => {
  const capabilities = Array.isArray(capability) ? capability : [capability];
  return capabilities.reduceRight(
    (content, capability) => (
      <RestrictedByCapabilityWithDebug
        capability={capability}
        otherwise={otherwise}
      >
        {content}
      </RestrictedByCapabilityWithDebug>
    ),
    <RestrictedByDocumentPermissionByTypeWithDebug
      permissionByType={permissionByType}
      document={document}
      otherwise={otherwise}
      {...props}
    >
      {children}
    </RestrictedByDocumentPermissionByTypeWithDebug>
  );
};
